module.exports = __webpack_public_path__ + "img/motorbikeRearRight.34f9d68f.svg";